import { LINKS } from "@/static-texts/links";
import RequestOkComponent from "./request-ok";
import { useHistory } from "react-router-dom";
function RequestOk() {
  const history = useHistory();
  const handleBackToHomeClick = () => {
    history.push(LINKS.HOME);
  };
  return <RequestOkComponent onBackToHomeClick={handleBackToHomeClick} />;
}

export default RequestOk;
